import { makeReconciler } from '@use-gpu/live';

export const EventReconciler = makeReconciler('EventReconciler');
export const QueueReconciler = makeReconciler('QueueReconciler');
export const PassReconciler = makeReconciler('PassReconciler');
export const LayerReconciler = makeReconciler('LayerReconciler');
